<template>
    <div class="income">
        <HeaderReturn title="我的收益"></HeaderReturn>
        <div class="income_tabs">
            <van-tabs type="card">
                <van-tab title="认购">
                    <div class="income_ul">
                        <ul>
                            <li>
                                <div v-for="(item, index) in TeamList" @click="goLink('/My/incomeDeta',item)">
                                    <div>
                                        
                                        <p>
                                            {{ item.value }}
                                        </p>
                                        <p>
                                            {{ item.text }}
                                        </p>
                                    </div>


                                </div>
                            </li>
                        </ul>

                    </div>
                </van-tab>
                <van-tab title="矿机">
                    <div class="df">待开放</div>
                </van-tab>
            </van-tabs>
        </div>

    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon, Tab, Tabs } from 'vant';
Vue.use(NoticeBar).use(Icon).use(Tabs).use(Tab);
import vueQr from "vue-qr";
import {
    mainApiData
} from '@/request/api.js'
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    value: 100,
                    text: "静态收益(LQD)",
                    theTaterType:'sub_static_income',
                    name:"静态收益明细"
                },
                {
                    value: 100,
                    text: "推荐奖励(LQD)",
                    theTaterType:'sub_straight_income',
                    name:"推荐奖励明细"
                },
                {
                    value: 100,
                    text: "团队级差收益(LQD)",
                    theTaterType:'sub_diff_income',
                    name:"团队级差收益明细"
                }, {
                    value: 100,
                    text: "平级收益(LQD)",
                    theTaterType:'sub_flat_diff_income',
                    name:"平级收益明细"
                },
            ],
            AccasetList: [{
                name: '4321',
                value: 100,
                freeze: 100,
                id: 0,
                type: 1,
            }, {
                name: '4321',
                value: 100,
                freeze: 100,
                id: 1,
                type: 1,
            }, {
                name: '4321',
                value: 100,
                freeze: 100,
                id: 2,
                type: 1,
            }],
            performanceList: {
                total: 99999,
                region: 77777,
                plot: 33333
            }


        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
        this.Init();
    },
    methods: {
        Init() {
            mainApiData.myIncome().then((res)=>{
                if(res.data.code==200){
                    this.TeamList[0].value=res.data.data.staticIncome;
                    this.TeamList[1].value=res.data.data.straightIncome;
                    this.TeamList[2].value=res.data.data.diffIncome;
                    this.TeamList[3].value=res.data.data.flatDiffIncome;

                }
            })
        },
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        item: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.income {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .df{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #f89b19;
        font-weight: 600;
        font-size: 20px;
        // margin-top: 150px;
        position: fixed;
        top: 50%;
        left: 0;
        right: 0;
        
    }

    .income_ul {
        padding: 25px 10px;

        ul {
            li {

                display: grid;
                justify-content: space-between;
                grid-template-columns: 47% 47%;
                // margin: 20px 0;

                div {
                    margin: 10px 0 0px 0;

                    div {
                        // background: rgba(20, 132, 195, 0.2);
                        /* 黄/主题 */

                        border: 0.5px solid #f89b19;
                        // box-shadow: 0px 0px 10px 4px rgba(20, 132, 195, 0.25), inset 0px 0px 10px -4px rgba(20, 132, 195, 0.25);
                        border-radius: 4px;

                        p {
                            &:nth-child(1) {
                                padding: 15px 10px 0px 10px;

                                font-family: 'PingFang SC';
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px;
                                color: #f89b19;

                           
                                font-size: 16px;

                            }

                            &:nth-child(2) {
                                padding: 14px 10px 10px 10px;

                                font-family: 'PingFang SC';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 28px;


                                color: #9C9C9C;
                            }
                        }
                    }

                    // background: rgba(20, 132, 195, 0.2);
                    // /* 黄/主题 */

                    // border: 0.5px solid #f89b19;
                    // box-shadow: 0px 0px 10px 4px rgba(20, 132, 195, 0.25), inset 0px 0px 10px -4px rgba(20, 132, 195, 0.25);
                    // border-radius: 4px;

                }
            }
        }
    }

    .income_tabs {

        ::v-deep .van-tab.van-tab--active {
            // background: rgba(20, 132, 195, 0.5);
            background: #f89b19;
            // border: solid 1px rgb(21,133,196);
        }

        ::v-deep .van-tabs__nav--card {
            // background: rgba(20, 132, 195, 0.2);
            background: transparent;

            border: 1px solid #f89b19 !important;
        }

        ::v-deep .van-tabs__nav {

            border-radius: 4px;
            // border: solid 1px rgb(47,75,90);
        }
    }


}
</style>